import { Primary } from '@cinch-labs/design-system'
import { Wrapper } from '@cinch-nx/shared-ui'
import { FindACarCtaText } from '../../types/locales'
import styles from './find-a-car-cta.module.css'

import { scrollToElement } from './find-a-car-cta.helpers'
import { useAnalytics } from '@cinch-nx/shared-analytics'
import { financeBudgetTopButton } from '../../tracking/tracking-events'

interface FindACarCtaProps {
  i18n: FindACarCtaText
  triggerPointRef: React.RefObject<HTMLDivElement>
}

function FindACarCta({ i18n, triggerPointRef }: FindACarCtaProps) {
  const { trackEvent } = useAnalytics()

  return (
    <Wrapper
      className={{
        container: styles.findACarCtaContainer,
        inner: styles.findACarCtaInner,
      }}
    >
      <Primary
        classNames={{ button: styles.findACarCta }}
        onClick={() => {
          scrollToElement(triggerPointRef)
          trackEvent(financeBudgetTopButton())
        }}
      >
        {i18n.ctaText}
      </Primary>
    </Wrapper>
  )
}

export default FindACarCta
